"use strict";
/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StatsCrimeLocalAuthority$ = exports.StatsCrimeLocalAuthority$outboundSchema = exports.StatsCrimeLocalAuthority$inboundSchema = void 0;
exports.statsCrimeLocalAuthorityToJSON = statsCrimeLocalAuthorityToJSON;
exports.statsCrimeLocalAuthorityFromJSON = statsCrimeLocalAuthorityFromJSON;
const z = __importStar(require("zod"));
const primitives_js_1 = require("../../../lib/primitives.js");
const schemas_js_1 = require("../../../lib/schemas.js");
/** @internal */
exports.StatsCrimeLocalAuthority$inboundSchema = z.object({
    local_authority_code: z.string(),
    local_authority_name: z.string(),
    total_crime_percentage_change_excluding_fraud: z.number(),
    total_crime_rate_excluding_fraud: z.number(),
    total_recorded_crime_excluding_fraud: z.number(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        "local_authority_code": "localAuthorityCode",
        "local_authority_name": "localAuthorityName",
        "total_crime_percentage_change_excluding_fraud": "totalCrimePercentageChangeExcludingFraud",
        "total_crime_rate_excluding_fraud": "totalCrimeRateExcludingFraud",
        "total_recorded_crime_excluding_fraud": "totalRecordedCrimeExcludingFraud",
    });
});
/** @internal */
exports.StatsCrimeLocalAuthority$outboundSchema = z.object({
    localAuthorityCode: z.string(),
    localAuthorityName: z.string(),
    totalCrimePercentageChangeExcludingFraud: z.number(),
    totalCrimeRateExcludingFraud: z.number(),
    totalRecordedCrimeExcludingFraud: z.number(),
}).transform((v) => {
    return (0, primitives_js_1.remap)(v, {
        localAuthorityCode: "local_authority_code",
        localAuthorityName: "local_authority_name",
        totalCrimePercentageChangeExcludingFraud: "total_crime_percentage_change_excluding_fraud",
        totalCrimeRateExcludingFraud: "total_crime_rate_excluding_fraud",
        totalRecordedCrimeExcludingFraud: "total_recorded_crime_excluding_fraud",
    });
});
/**
 * @internal
 * @deprecated This namespace will be removed in future versions. Use schemas and types that are exported directly from this module.
 */
var StatsCrimeLocalAuthority$;
(function (StatsCrimeLocalAuthority$) {
    /** @deprecated use `StatsCrimeLocalAuthority$inboundSchema` instead. */
    StatsCrimeLocalAuthority$.inboundSchema = exports.StatsCrimeLocalAuthority$inboundSchema;
    /** @deprecated use `StatsCrimeLocalAuthority$outboundSchema` instead. */
    StatsCrimeLocalAuthority$.outboundSchema = exports.StatsCrimeLocalAuthority$outboundSchema;
})(StatsCrimeLocalAuthority$ || (exports.StatsCrimeLocalAuthority$ = StatsCrimeLocalAuthority$ = {}));
function statsCrimeLocalAuthorityToJSON(statsCrimeLocalAuthority) {
    return JSON.stringify(exports.StatsCrimeLocalAuthority$outboundSchema.parse(statsCrimeLocalAuthority));
}
function statsCrimeLocalAuthorityFromJSON(jsonString) {
    return (0, schemas_js_1.safeParse)(jsonString, (x) => exports.StatsCrimeLocalAuthority$inboundSchema.parse(JSON.parse(x)), `Failed to parse 'StatsCrimeLocalAuthority' from JSON`);
}
//# sourceMappingURL=statscrimelocalauthority.js.map